import React from 'react';
import Typography from "../typography/Typography";
import BaseModal from "../BaseModal";

import { StyledModalSuccess } from './style';

interface ModalProps {
  toggleModal: boolean;
  setToggleModal: React.Dispatch<boolean>;
  title: string;
  text: string;
}

export const ModalSuccess = ({toggleModal, setToggleModal, title, text}: ModalProps) => {
  return(
    <BaseModal onCancel={() => setToggleModal(false)} footer={null} title={title} setToggleModal={setToggleModal} toggleModal={toggleModal}>
      <StyledModalSuccess>
        <svg width="65" height="65" viewBox="0 0 71 73" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="35.8156" cy="41" r="32" fill="#ACECD6"></circle><path d="M66.0112 2.27098C54.9164 15.1924 43.8218 28.1137 32.727 41.0351C28.3865 36.2046 24.0458 31.3741 19.7052 26.5435C17.5499 24.145 14.0232 27.6904 16.1696 30.0791C21.1129 35.5802 26.0561 41.0814 30.9994 46.5827C31.8542 47.5339 33.6879 47.5692 34.535 46.5827C46.2056 32.9906 57.876 19.3986 69.5466 5.80648C71.6327 3.37698 68.1117 -0.175323 66.0112 2.27098Z" fill="#3A625C"></path><path d="M61.8586 24.0566C66.0936 37.714 60.6067 52.5876 47.6311 59.1845C36.041 65.0771 21.4518 62.2227 12.9206 52.4207C4.36546 42.5911 3.50526 27.8322 10.9152 17.097C19.5584 4.57489 36.2644 1.38449 49.3421 8.70739C52.1528 10.2812 54.6766 5.96399 51.8657 4.38999C28.3225 -8.79301 -1.92524 9.36109 1.01446 36.9268C3.72116 62.3074 33.8564 76.02 54.5824 60.7412C66.4886 51.9641 71.0218 36.7293 66.68 22.7274C65.73 19.6637 60.9018 20.971 61.8586 24.0566Z" fill="#3A625C"></path></svg>
        <Typography type='body1' color='title'>{text}</Typography>
      </StyledModalSuccess>
    </BaseModal>
  );
}